import { useState } from 'react'
import { useResErrors } from 'hooks/index'
import { TaskService } from 'lib/api'

function useTaskApis() {
  const [loading, setLoading] = useState(false)
  const { standardCheck } = useResErrors()

  const createTask = async ({
    data,
    onSuccess = () => {},
    onFail = () => {},
    textErr
  }) => {
    setLoading(true)

    await TaskService.addEvent(data).then(response =>
      standardCheck(response, onSuccess, {
        onFail,
        textErr
      })
    )

    setLoading(false)
  }

  const updateTask = async ({
    data,
    onSuccess = res => {},
    onFail = () => {},
    textErr
  }) => {
    setLoading(true)
    await TaskService.updateEvent(data).then(res =>
      standardCheck(res, onSuccess, {
        onFail,
        textErr
      })
    )
    setLoading(false)
  }

  const completeEvent = async ({
    data,
    onSuccess = res => {},
    onFail = () => {},
    textErr
  }) => {
    setLoading(true)
    await TaskService.completeEvent(data).then(res =>
      standardCheck(res, onSuccess, {
        onFail,
        textErr
      })
    )
    setLoading(false)
  }

  const getMyEvents = async ({
    data,
    limit,
    offset,
    onSuccess = res => {},
    onFail = () => {},
    textErr
  }) => {
    setLoading(true)
    await TaskService.getMyEvents(data, limit, offset).then(res =>
      standardCheck(res, onSuccess, {
        onFail,
        textErr
      })
    )
    setLoading(false)
  }
  const getEvents = async ({
    data,
    limit,
    offset,
    onSuccess = res => {},
    onFail = () => {},
    textErr
  }) => {
    setLoading(true)
    await TaskService.getEvents(data, limit, offset).then(res =>
      standardCheck(res, onSuccess, {
        onFail,
        textErr
      })
    )
    setLoading(false)
  }
  const getNotCompletedEventsBySaleId = async ({
    saleId,
    type = null,
    onSuccess = res => {},
    onFail = () => {},
    textErr
  }) => {
    setLoading(true)
    await TaskService.getMyEvents(
      { dealId: saleId, completed: false, ...(type ? { types: [type] } : {}) },
      100,
      0
    ).then(res =>
      standardCheck(res, onSuccess, {
        onFail,
        textErr
      })
    )
    setLoading(false)
  }

  return {
    taskIsLoading: loading,
    createTask,
    updateTask,
    getEvents,
    getMyEvents,
    getNotCompletedEventsBySaleId,
    completeEvent
  }
}
export default useTaskApis
